import { createWelcomeStep, createMiddleStep, createFinalStep } from '../config/stepTemplates';

const TOTAL = 5;

export function getDashboardTourSteps(t) {
  return [
    createWelcomeStep({
      id: 'dashboard-welcome',
      title: t('onboarding_tour.dashboard.step1.title', 'Welcome to Lawis'),
      text: t('onboarding_tour.dashboard.step1.text', 'Your command center. See your contracts, legal news, and business announcements at a glance.'),
      attachTo: { element: '[data-tour="dashboard-header"]', on: 'bottom' },
      t,
      totalSteps: TOTAL,
    }),
    createMiddleStep({
      id: 'dashboard-pipeline',
      title: t('onboarding_tour.dashboard.step2.title', 'Contract Pipeline'),
      text: t('onboarding_tour.dashboard.step2.text', 'Track your contracts through every stage — from draft to signed. Click any stage to filter.'),
      attachTo: { element: '[data-tour="contract-stage-cards"]', on: 'bottom' },
      t,
      stepIndex: 2,
      totalSteps: TOTAL,
    }),
    createMiddleStep({
      id: 'dashboard-recent',
      title: t('onboarding_tour.dashboard.step3.title', 'Recent Contracts'),
      text: t('onboarding_tour.dashboard.step3.text', 'Quick access to your latest contracts. Click to continue editing.'),
      attachTo: { element: '[data-tour="contract-recent-work"]', on: 'top' },
      t,
      stepIndex: 3,
      totalSteps: TOTAL,
    }),
    createMiddleStep({
      id: 'dashboard-news',
      title: t('onboarding_tour.dashboard.step4.title', 'Legal News'),
      text: t('onboarding_tour.dashboard.step4.text', 'Latest legal news and regulatory updates relevant to your practice.'),
      attachTo: { element: '[data-tour="legal-news-widget"]', on: 'left' },
      t,
      stepIndex: 4,
      totalSteps: TOTAL,
    }),
    createFinalStep({
      id: 'dashboard-annonces',
      title: t('onboarding_tour.dashboard.step5.title', 'Business Announcements'),
      text: t('onboarding_tour.dashboard.step5.text', 'Monitor official legal announcements and company publications.'),
      attachTo: { element: '[data-tour="annonces-widget"]', on: 'top' },
      t,
      totalSteps: TOTAL,
    }),
  ];
}
